import makeFetch from "../../utils/http";
import { routes } from "../../Constants/api";

export function api_geChatId({appointmentId}) {
    return makeFetch(
        `${routes.chats}?appointmentId=${appointmentId}`,
        "GET"
    );
}

export function api_getChannel({chatId}) {
    return makeFetch(
        `${routes.chats}/${chatId}`,
        "GET"
    );
}

export function api_getMessagesCount({chatId}) {
    return makeFetch(
        `${routes.chats}/${chatId}/${routes.messages}/count`,
        "GET"
    );
}

export function api_getMessages({chatId}) {
    return makeFetch(
        `${routes.chats}/${chatId}/${routes.messages}`,
        "GET",
        {limit: 10000}
    );
}

export function api_postMessage({chatId, body}) {
    return makeFetch(
        `${routes.chats}/${chatId}/${routes.messages}`,
        "POST",
        {},
        JSON.stringify(body)
    );
}

export function api_getAmazonUrl({chatId}) {
    return makeFetch(
        `${routes.chats}/${chatId}/upload`,
        "GET"
    );
}

export function api_updateTyping({chatId, body}) {
    return makeFetch(
        `${routes.chats}/${chatId}/${routes.messages}/startType`,
        "POST",
        {},
        JSON.stringify(body)
    );
}

export function api_sendPushNotification({userID, body}) {
    return makeFetch(
        `notifications/user/${userID}/type/push`,
        "POST",
        {},
        JSON.stringify(body),
        true,
        "same-origin",
        true
    );
}
